import React from 'react';
import styles from '../OrderList.module.css';

function SortDay({ setFilterDate, filterDate }) {
    return (
        <div className={styles['shopify-date-filter']}>
            <select
                name="filterData"
                className={styles['shopify-select']}
                value={filterDate}
                onChange={(e) => setFilterDate(e.target.value)}
            >
                <option value="Today">Today</option>
                <option value="Yesterday">Yesterday</option>
                <option value="7 Days">This Week</option>
                <option value="Month">This Month</option>
                <option value="Last Month">Last Month</option>
                <option value="all">All Orders</option>
            </select>
        </div>
    );
}

export default SortDay;
